<template>
    <div>
        <div class="img-content">
            <img src="../assets/images/main.jpg" alt="">
        </div>
        
        <h1>Product Detail Page</h1>
        <p>Product ID: {{ productId }}</p>
    </div>
</template>

<script>
export default {
    name: 'ProductDetailPage',
    data() {
        return {
            productId: ''
        };
    },
    created() {
        // 初始化时获取一次参数
        this.productId = this.$route.params.productId;
    },
    watch: {
        '$route.params.productId'(newProductId) {
            // 监听路由参数的变化，当参数变化时更新组件内的数据
            this.productId = newProductId;
        }
    }
};
</script>
<style>
.img-content img {
    width: 100%;
}
</style>